import { m } from '~/paraglide/messages'

export function GeneralTrackBadge() {
  return (
    <div className="relative h-[80px] w-[100px]">
      <svg
        width="100"
        height="79"
        viewBox="0 0 100 79"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32 1H68C73.617 1 77.7698 1.00115 81.0547 1.26953C84.3278 1.53697 86.6514 2.06517 88.626 3.07129C92.2008 4.89284 95.1072 7.79917 96.9287 11.374C97.9348 13.3486 98.463 15.6722 98.7305 18.9453C98.9989 22.2302 99 26.383 99 32V37.8799C99 45.707 98.9852 49.3642 97.8203 52.5137C96.7777 55.3324 95.081 57.8636 92.8701 59.8994C90.3999 62.174 87.0235 63.5774 79.7842 66.5527L61.5557 74.0449C56.9948 75.9194 54.8622 76.7891 52.6709 77.1309C50.704 77.4376 48.7009 77.4333 46.7354 77.1182C44.5456 76.7671 42.417 75.8881 37.8643 73.9941L20.0928 66.6016C12.8977 63.6084 9.54218 62.1964 7.08789 59.9229C4.89119 57.8879 3.20605 55.3625 2.1709 52.5527C1.01437 49.4134 1 45.7726 1 37.9795V32C1 26.383 1.00115 22.2302 1.26953 18.9453C1.53697 15.6722 2.06517 13.3486 3.07129 11.374C4.89284 7.79917 7.79917 4.89284 11.374 3.07129C13.3486 2.06517 15.6722 1.53697 18.9453 1.26953C22.2302 1.00115 26.383 1 32 1Z"
          stroke="url(#paint0_linear_20814_26814)"
          strokeWidth="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_20814_26814"
            x1="50"
            y1="0"
            x2="50"
            y2="80"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0.5" />
            <stop offset="1" stopColor="white" />
          </linearGradient>
        </defs>
      </svg>

      <span className="absolute left-0 right-0 top-[26px] mx-auto w-[90px] text-center text-sm font-bold text-white">
        {m.event_reward_text()}
      </span>
    </div>
  )
}
